import type { ComponentLike } from "@glint/template";

declare const IconsX: ComponentLike<{ Element: SVGElement }>;
export default IconsX;
